function Taller() {
  return (
    <div>
      <h1>Vista del Taller</h1>
    </div>
  );
}

export default Taller;